const Constants = require('EurestoFonction/Constants')
const Data = require('EurestoClass/Data')
const User = require('EurestoClass/User')

module.exports = (option) => console.log(
    "MY OPTION IS", Data.default.list(Constants.default.module.CONFIGURATION, Constants.default.donnee.option)
) || Data.default.list(Constants.default.module.CONFIGURATION, Constants.default.donnee.option).indexOf(option) !== -1
&&
    (
        User.default.User.get().type === Constants.default.access.EURESTO || true ||
        Data.default.get(Constants.default.module.CONFIGURATION, Constants.default.donnee.profil, 
            {id: User.default.User.get().profil_v2_id}).droits.findIndex(d => d.option_id === option && d.autorisation === 'X1XX') !== -1
        )


// WEBPACK FOOTER //
// ./app/Utilitaire/Function/Option.js